import React from 'react';
import styled from 'styled-components';

const Layer = styled.div`
  position: absolute;
  top: 0;
  pointer-events: none;
  overflow: hidden;

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }

  @media (min-width: 883px) {
    height: 72px;
  }

  @media (max-width: 882px) {
    height: 104px;
    width: 45%;
    max-width: 168px;
  }
`;

const LayerLeft = styled(Layer)`
  left: 0;

  @media (min-width: 883px) {
    width: 742px;
    max-width: none;
  }

  @media (max-width: 882px) {
    max-width: 168px;
  }
`;

const LayerRight = styled(Layer)`
  right: 0;

  @media (min-width: 883px) {
    width: 797px;
    max-width: none;
  }

  @media (max-width: 882px) {
    left: auto;
    max-width: 168px;
  }
`;

export const BannerBackground = () => (
  <>
    <LayerLeft aria-hidden>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 742 72" preserveAspectRatio="none" fill="none">
        <path d="M226.505 0H0V72H742L226.505 0Z" fill="url(#banner-promo-bg-left)" />
        <defs>
          <linearGradient
            id="banner-promo-bg-left"
            x1="178.875"
            y1="43.7143"
            x2="193.975"
            y2="-20.512"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0E913C" />
            <stop offset="1" stopColor="#22AA52" stopOpacity="0.3" />
          </linearGradient>
        </defs>
      </svg>
    </LayerLeft>
    <LayerRight aria-hidden>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 797 72" preserveAspectRatio="none" fill="none">
        <path d="M553.705 0H797V72H0L553.705 0Z" fill="url(#banner-promo-bg-right)" />
        <defs>
          <linearGradient
            id="banner-promo-bg-right"
            x1="604.866"
            y1="43.7143"
            x2="590.709"
            y2="-20.9635"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0E913C" />
            <stop offset="1" stopColor="#22AA52" stopOpacity="0.3" />
          </linearGradient>
        </defs>
      </svg>
    </LayerRight>
  </>
);
